/**
 * @flow
 * @relayHash 9cb0044b370ce51a2354476534482f9d
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type UpdateTutoringCompanyMutationVariables = {|
  input: {
    id: string;
    name: string;
    description: string;
    referralCode: string;
    internalMargin: number;
    externalMargin: number;
    clientMutationId?: ?string;
  };
|};
export type UpdateTutoringCompanyMutationResponse = {|
  +updateTutoringCompany: ?{|
    +clientMutationId: ?string;
    +tutoringCompany: ?{|
      +id: string;
    |};
  |};
|};
*/


/*
mutation UpdateTutoringCompanyMutation(
  $input: UpdateTutoringCompanyMutationInput!
) {
  updateTutoringCompany(input: $input) {
    clientMutationId
    tutoringCompany {
      id
      ...EditTutoringCompany_company
    }
  }
}

fragment EditTutoringCompany_company on TutoringCompany {
  id
  name
  description
  referralCode
  internalMargin
  externalMargin
  studentCount
  students {
    edges {
      node {
        id
        fullname
      }
    }
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "UpdateTutoringCompanyMutationInput!",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateTutoringCompanyMutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "UpdateTutoringCompanyMutationInput!"
          }
        ],
        "concreteType": "UpdateTutoringCompanyMutationPayload",
        "name": "updateTutoringCompany",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "clientMutationId",
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "TutoringCompany",
            "name": "tutoringCompany",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              },
              {
                "kind": "FragmentSpread",
                "name": "EditTutoringCompany_company",
                "args": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "UpdateTutoringCompanyMutation",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "UpdateTutoringCompanyMutationInput!",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "UpdateTutoringCompanyMutation",
    "operation": "mutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "UpdateTutoringCompanyMutationInput!"
          }
        ],
        "concreteType": "UpdateTutoringCompanyMutationPayload",
        "name": "updateTutoringCompany",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "clientMutationId",
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "TutoringCompany",
            "name": "tutoringCompany",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "name",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "description",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "referralCode",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "internalMargin",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "externalMargin",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "studentCount",
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "StudentConnection",
                "name": "students",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "StudentEdge",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "Student",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "id",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "fullname",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "mutation UpdateTutoringCompanyMutation(\n  $input: UpdateTutoringCompanyMutationInput!\n) {\n  updateTutoringCompany(input: $input) {\n    clientMutationId\n    tutoringCompany {\n      id\n      ...EditTutoringCompany_company\n    }\n  }\n}\n\nfragment EditTutoringCompany_company on TutoringCompany {\n  id\n  name\n  description\n  referralCode\n  internalMargin\n  externalMargin\n  studentCount\n  students {\n    edges {\n      node {\n        id\n        fullname\n      }\n    }\n  }\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// ./src/modules/admin/company/mutations/__generated__/UpdateTutoringCompanyMutation.graphql.js